import { PendoMetrics } from "@prestosports/commons-ui";
import React from "react";
import { useAuthContext } from "../../state/authentication/context";

const pendoAPIKey = process.env.REACT_APP_PENDO_API_KEY;
const pendoEnabled = process.env.REACT_APP_ENV !== "local";

const Metrics = () => {
	const { state } = useAuthContext();

	const profile = state.profile();
	const { username, name, lastName, id, su } = profile;

	return username && pendoEnabled ? (
		<PendoMetrics
			apiKey={pendoAPIKey}
			accountId={id}
			email={username}
			firstName={name}
			lastName={lastName}
			su={su > 0}
		/>
	) : null;
};

export default Metrics;
